<template>
  <div>
    <el-form label-position="top" label-width="90px">
      <el-form-item label="选择审批对象" prop="text" class="user-type">
        <a-radio-group v-model="nodeProps.assignedType" @change="e => changeUser(e)">
          <a-radio v-for="t in approvalTypes" :key="t.type" :value="t.type">{{ t.name }}</a-radio>
        </a-radio-group>
        <div v-if="nodeProps.assignedType === 'ASSIGN_USER'">
          <a-button icon="plus" type="primary" @click="selectUser" shape="round">选择人员</a-button>
          <org-items v-model="nodeProps.assignedUser"/>
        </div>
        <div v-else-if="nodeProps.assignedType === 'SELF_SELECT'">
          <a-radio-group size="mini" v-model="nodeProps.selfSelect.multiple">
            <a-radio-button :label="false">自选一个人</a-radio-button>
            <a-radio-button :label="true">自选多个人</a-radio-button>
          </a-radio-group>
        </div>
        <div v-else-if="nodeProps.assignedType === 'LEADER_TOP'">
          <el-divider/>
          <el-form-item label="审批终点" prop="text" class="approve-end">
            <a-radio-group v-model="nodeProps.leaderTop.endCondition">
              <a-radio label="TOP">直到最上层主管</a-radio>
              <a-radio label="LEAVE">不超过发起人的</a-radio>
            </a-radio-group>
            <div class="approve-end-leave" v-if="nodeProps.leaderTop.endCondition === 'LEAVE'">
              <span>第 </span>
              <a-input-number :min="1" :max="20" :step="1" v-model="nodeProps.leaderTop.level"/>
              <span> 级主管</span>
            </div>
          </el-form-item>
        </div>
        <div v-else-if="nodeProps.assignedType === 'LEADER'">
          <el-divider/>
          <el-form-item label="指定主管" prop="text">
            <span>发起人的第 </span>
            <a-input-number
              :min="1"
              :max="20"
              :step="1"
              v-model="nodeProps.leader.level"></a-input-number>
            <span> 级主管</span>
            <div style="color: #409EFF; font-size: small;">👉 直接主管为 第 1 级主管</div>
          </el-form-item>
        </div>
        <div v-else-if="nodeProps.assignedType === 'ROLE'">
          <a-button icon="plus" type="primary" @click="selectRole" shape="round">选择角色</a-button>
          <org-items v-model="nodeProps.role"/>
        </div>
        <div v-else-if="nodeProps.assignedType === 'ROLE_CATEGORY'">
          <a-button icon="plus" type="primary" @click="selectRoleCategory" shape="round">选择角色类型</a-button>
          <org-items v-model="nodeProps.role_category"/>
        </div>
        <div v-else-if="nodeProps.assignedType === 'FORM_USER'">
          <el-form-item label="选择表单联系人项" prop="text" class="approve-end">
            <el-select style="width: 80%;" size="small" v-model="nodeProps.formUser" placeholder="请选择包含联系人的表单项">
              <el-option v-for="op in forms" :label="op.title" :value="op.id" :key="op.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div v-else>
          <span class="item-desc">发起人自己作为审批人进行审批</span>
        </div>
      </el-form-item>

      <a-divider v-if="false"></a-divider>
      <el-form-item v-if="false" label="👤 审批人为空时" prop="text" class="line-mode">
        <a-radio-group v-model="nodeProps.nobody.handler">
          <a-radio value="TO_PASS">自动通过</a-radio>
          <a-radio value="TO_REFUSE">自动驳回</a-radio>
          <a-radio value="TO_ADMIN">转交审批管理员</a-radio>
          <a-radio value="TO_USER">转交到指定人员</a-radio>
        </a-radio-group>

        <div style="margin-top: 10px" v-if="nodeProps.nobody.handler === 'TO_USER'">
          <a-button icon="plus" type="primary" @click="selectNoSetUser" shape="round">选择人员</a-button>
          <org-items v-model="nodeProps.assignedUser"/>
        </div>

      </el-form-item>

      <div v-if="showMode">
        <a-divider/>
        <el-form-item label="多人审批时审批方式" prop="text" class="approve-mode">
          <a-radio-group v-model="nodeProps.mode">
            <a-radio value="NEXT" v-if="false">会签 （按选择顺序审批，每个人必须同意）</a-radio>
            <a-radio value="AND">会签（可同时审批，每个人必须同意）</a-radio>
            <a-radio value="OR">或签（有一人同意即可）</a-radio>
          </a-radio-group>
        </el-form-item>
      </div>

      <el-divider v-if="false">高级设置</el-divider>
      <el-form-item v-if="false" label="✍ 审批同意时是否需要签字" prop="text">
        <el-switch inactive-text="不用" active-text="需要" v-model="nodeProps.sign"></el-switch>
        <el-tooltip class="item" effect="dark" content="如果全局设置了需要签字，则此处不生效" placement="top-start">
          <i class="el-icon-question" style="margin-left: 10px; font-size: medium; color: #b0b0b1"></i>
        </el-tooltip>
      </el-form-item>
      <el-form-item v-if="false" label="⏱ 审批期限（为 0 则不生效）" prop="timeLimit">
        <a-input
          style="width: 180px;"
          placeholder="时长"
          size="small"
          type="number"
          v-model="nodeProps.timeLimit.timeout.value">
          <el-select style="width: 75px;" v-model="nodeProps.timeLimit.timeout.unit" slot="append" placeholder="请选择">
            <el-option label="天" value="D"></el-option>
            <el-option label="小时" value="H"></el-option>
          </el-select>
        </a-input>
      </el-form-item>
      <el-form-item label="审批期限超时后执行" prop="level" v-if="nodeProps.timeLimit.timeout.value > 0 && false">
        <el-radio-group v-model="nodeProps.timeLimit.handler.type">
          <el-radio label="PASS">自动通过</el-radio>
          <el-radio label="REFUSE">自动驳回</el-radio>
          <el-radio label="NOTIFY">发送提醒</el-radio>
        </el-radio-group>
        <div v-if="nodeProps.timeLimit.handler.type === 'NOTIFY'">
          <div style="color:#409EEF; font-size: small">默认提醒当前审批人</div>
          <el-switch inactive-text="循环" active-text="一次" v-model="nodeProps.timeLimit.handler.notify.once"></el-switch>
          <span style="margin-left: 20px" v-if="!nodeProps.timeLimit.handler.notify.once">
            每隔
            <el-input-number
              :min="0"
              :max="10000"
              :step="1"
              size="mini"
              v-model="nodeProps.timeLimit.handler.notify.hour"/>
            小时提醒一次
          </span>
        </div>
      </el-form-item>
      <el-form-item v-if="false" label="🙅‍ 如果审批被驳回 👇">
        <el-radio-group v-model="nodeProps.refuse.type">
          <el-radio label="TO_END">直接结束流程</el-radio>
          <el-radio label="TO_BEFORE">驳回到上级审批节点</el-radio>
          <el-radio label="TO_NODE">驳回到指定节点</el-radio>
        </el-radio-group>
        <div v-if="nodeProps.refuse.type === 'TO_NODE'">
          <span>指定节点:</span>
          <el-select style="margin-left: 10px; width: 150px;" placeholder="选择跳转步骤" size="small" v-model="nodeProps.refuse.target">
            <el-option v-for="(node, i) in nodeOptions" :key="i" :label="node.name" :value="node.id"></el-option>
          </el-select>
        </div>

      </el-form-item>
    </el-form>
    <dept-picker
      v-if="visible"
      :title="pickerTitle"
      multiple
      :type="pickerType"
      ref="orgPicker"
      :selected="orgPickerSelected"
      @ok="selected"
      @close="close"/>
    <role-picker
      v-if="roleVisible"
      title="请选择角色"
      multiple
      ref="rolePicker"
      :selected="rolePickerSelected"
      @ok="roleSelected"
      @close="close"/>
    <role-category-picker
      v-if="roleCategoryVisible"
      :title="pickerTitle"
      multiple
      :type="pickerType"
      ref="roleCategoryPicker"
      :selected="roleCategoryPickerSelected"
      @ok="roleCategorySelected"
      @close="close"
    />
    <user-picker
      type="user"
      v-if="userVisible"
      title="请选择"
      multiple
      ref="userPicker"
      :selected="userPickerSelected"
      @ok="userSelected"
      @close="close"/>
  </div>
</template>

<script>
import DeptPicker from '@/components/common/DeptPicker'
import OrgPicker from '@/components/common/OrgPicker'
import RolePicker from '@/components/common/RolePicker'
import RoleCategoryPicker from '@/components/common/RoleCategoryPicker'
import UserPicker from '@/components/common/UserPicker'
import OrgItems from '../OrgItems'
import { mapMutations } from 'vuex'

export default {
  name: 'ApprovalNodeConfig',
  components: { DeptPicker, OrgItems, OrgPicker, RolePicker, RoleCategoryPicker, UserPicker },
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      visible: false,
      roleVisible: false,
      roleCategoryVisible: false,
      userVisible: false,
      showOrgSelect: false,
      orgPickerSelected: [],
      rolePickerSelected: [],
      roleCategoryPickerSelected: [],
      userPickerSelected: [],
      pickerType: '',
      approvalTypes: [
        { name: '指定人员', type: 'ASSIGN_USER', value: 1 },
        // { name: '发起人自选', type: 'SELF_SELECT' },
        // { name: '连续多级主管', type: 'LEADER_TOP' },
        // { name: '主管', type: 'LEADER' },
        { name: '角色', type: 'ROLE' },
        { name: '角色类型', type: 'ROLE_CATEGORY', value: 2 }
        // { name: '发起人自己', type: 'SELF' },
        // { name: '表单内联系人', type: 'FORM_USER' }
      ]
    }
  },
  computed: {
    nodeProps () {
      return this.$store.state.oaApprove.selectedNode.props
    },
    select () {
      return this.config.assignedUser || []
      // switch (this.pickerType) {
      //   case 'user':
      //     return this.config.assignedUser || []
      //   case 'role':
      //     return this.config.role || []
      //   case 'role_category':
      //     return this.config.role_category || []
      //   default:
      //     return null
      // }
    },
    forms () {
      return this.$store.state.oaApprove.design.formItems.filter(f => {
        return f.name === 'UserPicker'
      })
    },
    pickerTitle () {
      switch (this.pickerType) {
        case 'user':
          return '请选择人员'
        case 'role':
          return '请选择角色'
        case 'role_category':
          return '请选择角色类型'
        default:
          return null
      }
    },
    nodeOptions () {
      const values = []
      const excType = ['ROOT', 'EMPTY', 'CONDITION', 'CONDITIONS', 'CONCURRENT', 'CONCURRENTS']
      this.$store.state.oaApprove.nodeMap.forEach((v) => {
        if (excType.indexOf(v.type) === -1) {
          values.push({ id: v.id, name: v.name })
        }
      })
      return values
    },
    showMode () {
      switch (this.nodeProps.assignedType) {
        case 'ASSIGN_USER':
          return this.nodeProps.assignedUser.length > 0
        case 'SELF_SELECT':
          return this.nodeProps.selfSelect.multiple
        case 'LEADER_TOP':
          return this.nodeProps.formUser !== ''
        case 'FORM_USER':
          return true
        case 'ROLE':
          // return true
          return this.nodeProps.role.length > 0
        case 'ROLE_CATEGORY':
          return true
        default:
          return false
      }
    }
  },
  methods: {
    ...mapMutations('oaApprove', ['setSelectedNodePropsAssignedType']),
    changeUser (e) {
      // this.$store.state.oaApprove.selectedNode.props.assignedType = user
      // this.$store.commit('setSelectedNodePropsAssignedType', user)
      this.$nextTick(() => {
        this.setSelectedNodePropsAssignedType(e.target.value)
      })
    },
    selectUser () {
      this.userPickerSelected = this.select
      this.pickerType = 'user'
      this.userVisible = true
      // this.$refs.orgPicker.show()
    },
    selectNoSetUser () {
      this.orgPickerSelected = this.config.nobody.assignedUser
      this.pickerType = 'user'
      this.visible = true
      // this.$refs.orgPicker.show()
    },
    selectRole () {
      this.rolePickerSelected = this.config.role || []
      this.roleVisible = true
    },
    selectRoleCategory () {
      // this.orgPickerSelected = this.select
      this.roleCategoryPickerSelected = this.config.role_category || []
      this.pickerType = 'role_category'
      this.roleCategoryVisible = true
      // this.$refs.orgPicker.show()
    },
    selected (select) {
      console.log('选择的数据是：', select)
      this.orgPickerSelected.length = 0
      select.forEach(val => this.orgPickerSelected.push(val))
      this.visible = false
    },
    roleSelected (select) {
      this.rolePickerSelected.length = 0
      select.forEach(val => this.rolePickerSelected.push(val))
      this.roleVisible = false
    },
    roleCategorySelected (select) {
      this.roleCategoryPickerSelected.length = 0
      select.forEach(val => this.roleCategoryPickerSelected.push(val))
      this.roleCategoryVisible = false
    },
    userSelected (select) {
      this.userPickerSelected.length = 0
      select.forEach(val => this.userPickerSelected.push(val))
      this.userVisible = false
    },
    close () {
      this.visible = false
      this.roleVisible = false
      this.userVisible = false
      this.roleCategoryVisible = false
    },
    removeOrgItem (index) {
      this.select.splice(index, 1)
    }
  }
}
</script>

<style lang="less" scoped>
.user-type {
  /deep/ .el-radio {
    width: 110px;
    margin-top: 10px;
    margin-bottom: 20px;
  }
}

/deep/ .line-mode {
  .el-radio {
    width: 150px;
    margin: 5px;
  }
}

/deep/ .el-form-item__label {
  line-height: 25px;
}

/deep/ .approve-mode {
  .el-radio {
    float: left;
    width: 100%;
    display: block;
    margin-top: 15px;
  }
}

/deep/ .approve-end {
  position: relative;

  .el-radio-group {
    width: 160px;
  }

  .el-radio {
    margin-bottom: 5px;
    width: 100%;
  }

  .approve-end-leave {
    position: absolute;
    bottom: -5px;
    left: 150px;
  }
}

/deep/ .el-divider--horizontal {
  margin: 10px 0;
}
</style>
